import { useState, useRef, useEffect } from 'react';
import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div ref={dropdownRef} className="relative w-full max-w-md mx-auto" id="categories">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between px-5 py-3.5 bg-background-50 border-2 border-background-200 rounded-xl text-left cursor-pointer hover:border-primary-300 transition-colors duration-200"
      >
        <span className="text-sm font-medium text-foreground-700 whitespace-nowrap">Browse Categories</span>
        <div className="w-5 h-5 flex items-center justify-center">
          <i className={`ri-arrow-down-s-line text-foreground-500 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}></i>
        </div>
      </button>

      {isOpen && (
        <div className="absolute top-full left-0 right-0 mt-2 bg-background-50 border border-background-200 rounded-xl shadow-lg z-40 max-h-80 overflow-y-auto">
          {categories.map((cat, idx) => (
            <a
              key={idx}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="flex items-center gap-3 px-5 py-3 hover:bg-background-100 transition-colors cursor-pointer border-b border-background-100 last:border-b-0"
            >
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-100/60 flex-shrink-0">
                <i className={`${cat.icon} text-accent-600 text-sm`}></i>
              </div>
              <span className="text-sm text-foreground-800 whitespace-nowrap">{cat.name}</span>
            </a>
          ))}
        </div>
      )}
    </div>
  );
}